import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { BetHistoryLegType } from 'src/domains/players/webview/components/Account/betHistoryTab/BetHistoryTab.state';
import { UsersState } from 'src/domains/players/state/UsersState';
import { useCommon } from 'src/domains/common/Common';

export const BetSPPriceInfo = observer<{ leg: BetHistoryLegType }>('BetSPPriceInfo', ({ leg }): JSX.Element | null => {
    const common = useCommon();
    const usersState = UsersState.get(common);

    const oddsFormat = usersState.oddsFormatShort;

    if (leg.priceType !== 'bp') {
        return null;
    }

    const spPrice = leg.spPrice ?? null;

    if (spPrice !== null) {
        const spPriceD = spPrice.d ?? null;
        const spPriceF = spPrice.f ?? null;

        return <div>SP - {oddsFormat === 'd' && spPriceD !== null ? spPriceD.toFixed(2) : spPriceF}</div>;
    }

    return null;
});
